<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <template v-if="userInfo.userRole == 'guest'">
        <img
          src="@/assets/images/pages/not-authorized.png"
          alt="graphic-not-authorized"
          class="mx-auto mb-4"
        />
        <h1 class="sm:mx-0 mx-4 sm:mb-3 mb-3 text-5xl d-theme-heading-color">
          Вы не авторизованы или у Вас недостаточно прав
        </h1>
        <p class="sm:mx-0 mx-4 sm:mb-12 mb-8">
          Вернитесь на страницу авторизации, чтобы войти в систему
        </p>
        <vs-button class="text-dark" size="large" :to="{ name: 'page-login' }"
          >Авторизоваться</vs-button
        >
      </template>
      <template v-else>
        <img
          src="@/assets/images/pages/404.png"
          alt="graphic-404"
          class="mx-auto mb-4"
        />
        <h1 class="sm:mx-0 mx-4 sm:mb-3 mb-3 text-5xl d-theme-heading-color">
          Упс!
        </h1>
        <p class="sm:mx-0 mx-4 sm:mb-12 mb-8">
          Что-то пошло не так или страница не найдена
        </p>
        <vs-button
          v-if="userInfo.userRole == 'security'"
          size="large"
          :to="{ name: 'passes' }"
          >Вернуться</vs-button
        >
        <vs-button v-else size="large" :to="{ name: 'home' }"
          >Вернуться на главную</vs-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    jwt() {
      return localStorage.getItem("accessToken");
    },
  },
};
</script>